import GeoJSON from 'ol/format/GeoJSON';

import { getIdPortenToken, logout } from './authentication'
import { warn } from '../notify'

const debug = false;

// Promise request: https://stackoverflow.com/a/30008115
export const getEmissions = (id, token, today) => new Promise((res, reject) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      // console.log(xhr.responseXML.title);
      const html = xhr.responseXML;
      const empty = !html.querySelector('td');
      // const empty = (html.querySelector('tbody').children.length === 0);
      if (empty) reject({ statusText: 'Planen ligger utenfor lovlig område' });
      else res(html.getElementById('utslipp') || 'Noe gikk galt');
    } else {
      const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
      const generic = 'Server svarer ikke';
      const unauthorized = (xhr.status === 401);
      if (unauthorized) logout();
      reject({ status: xhr.status, statusText: unauthorized ? ut : generic });
    }
  };
  xhr.onerror = () => reject({ status: xhr.status, statusText: xhr.statusText });
  const rid = `request_id=${id}`;
  const nå = today ? '&kategori_today=true' : ''; // default false
  xhr.open('GET', `/klimagasskalkulator_ws/calc?${rid}${nå}`, true);
  xhr.responseType = 'document';
  xhr.setRequestHeader('Content-Type', 'application/json');
  getIdPortenToken().then(idPortenToken => {
    xhr.setRequestHeader('nibiotoken', idPortenToken);
    xhr.send();
  }).catch(e => console.log(`${e}, pålogging kreves`));
  if (token) token.cancel = () => {
    xhr.abort();
    reject({ status: xhr.status, statusText: 'Brukeren avbrøyt' });
  };
});

// Promise request: https://stackoverflow.com/a/30008115
const sendToBackend = (data) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      // reject({ status: xhr.status, statusText: 'fake unauthorized' });
      const r = xhr.response;
      if (r.delCount && r.delCount > 0) warn(
        `${r.delCount} flate(r) ligger utenfor lovlig område og ble ignorert`
      );
      if (r.invalidCount && r.invalidCount > 0) warn(
        `${r.invalidCount} ugyldige geometrier ble ignorert`
      );
      resolve(r.requestId);
    } else {
      // reject({ status: xhr.status, statusText: xhr.statusText });
      const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
      const generic = 'Server svarer ikke';
      const unauthorized = (xhr.status === 401);
      if (unauthorized) logout();
      reject({ status: xhr.status, statusText: unauthorized ? ut : generic });
    }
  };
  xhr.onerror = () => {
    reject({ status: xhr.status, statusText: xhr.statusText });
  };
  xhr.open('POST', '/klimagasskalkulator_ws/geoupload', true);
  xhr.responseType = 'json';
  xhr.setRequestHeader('Content-Type', 'application/json');
  getIdPortenToken().then(idPortenToken => {
    xhr.setRequestHeader('nibiotoken', idPortenToken);
    xhr.send(data);
  }).catch(e => console.log(`${e}, pålogging kreves`));
});

export const sendFeaturesToBackend = (features) => {
  if (!debug && features.length === 0) return new Promise(() => '');
  // console.log('Sending geojson to back-end to get table back');

  // Write features to GeoJSON:
  const format = new GeoJSON();
  const geojson = !debug ? format.writeFeatures(features)
    : `{"type":"FeatureCollection","features":[{"type":"Feature","geometry":
    {"type":"Polygon","coordinates":[[[253729.62909063228,6622401.821298759],
    [253723.9432004237,6622284.312901115],[253823.4462790738,6622328.852374416],
    [253729.62909063228,6622401.821298759]]]},"properties":{"id":"571","title":
    "Område A","plankategori":"Nåværende","arealformål":"1001","komid":"3022"},
    "id":"571"}]}`
  ;
  return sendToBackend(geojson);
};

export const sendFileToBackend = (file) => {
  // console.log('Sending file to back-end to get table back', file);
  const formData = new FormData();
  formData.append('file', file);
  return sendToBackend(formData);
};

